export type CheckoutStatus = 'timeout' | 'success' | 'failure' | 'error';
